function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1317",
  "data-name": "Group 1317",
  transform: "translate(-79 -217)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_99",
  "data-name": "Component 34 \\u2013 99",
  transform: "translate(196.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1316",
  "data-name": "Group 1316"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1164",
  "data-name": "Group 1164",
  transform: "translate(56.5 18)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1003",
  "data-name": "Group 1003",
  transform: "translate(23.5 201.195)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M325.417-268.293a12.8,12.8,0,0,0-12.8-12.8,12.8,12.8,0,0,0-12.8,12.8v7.048a12.8,12.8,0,0,0,12.8,12.8,12.8,12.8,0,0,0,12.8-12.8Z",
  transform: "translate(-287.998 281.09)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M295.6-241.916l-8.287,3.347a3.177,3.177,0,0,0-1.988,2.946v5.557a3.6,3.6,0,0,0,3.6,3.6h42.04a3.6,3.6,0,0,0,3.6-3.6v-5.557a3.178,3.178,0,0,0-1.987-2.946l-8.288-3.347",
  transform: "translate(-285.324 273.866)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1017",
  "data-name": "Group 1017",
  transform: "translate(60.858 224.734)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1016",
  "data-name": "Group 1016"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M234.665-168.113a3.407,3.407,0,0,0-3.642-3.1H215.666a3.407,3.407,0,0,0-3.642,3.1v19.861a3.407,3.407,0,0,0,3.642,3.1h15.358a3.407,3.407,0,0,0,3.642-3.1Z",
  transform: "translate(-212.024 174.778)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-174.947H234.8v-3.5H220.819Z",
  transform: "translate(-216.49 178.45)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-115.93H234.8v-.877H220.819Z",
  transform: "translate(-216.49 146.939)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h22.5",
  transform: "translate(-212.097 170.141)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h22.5",
  transform: "translate(-212.097 152.253)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_747",
  "data-name": "Path 747",
  d: "M230.17-149.994s2.461,3.786,2.461,5.144a2.462,2.462,0,0,1-2.461,2.461,2.462,2.462,0,0,1-2.461-2.461C227.709-146.208,230.17-149.994,230.17-149.994Z",
  transform: "translate(-218.85 163.016)",
  fillRule: "evenodd"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1165",
  "data-name": "Group 1165",
  transform: "translate(210.537 -42)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1004",
  "data-name": "Group 1004",
  transform: "translate(23.963 260)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_589",
  "data-name": "Path 589",
  d: "M48.384-56.546a2.313,2.313,0,0,0-.678-1.636,2.313,2.313,0,0,0-1.636-.678H10.054a2.322,2.322,0,0,0-1.642.68,2.322,2.322,0,0,0-.68,1.642v41.567H48.384Z",
  transform: "translate(-3.485 62.953)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_590",
  "data-name": "Path 590",
  d: "M16.451-41.482H43.595v-8.684H16.451Z",
  transform: "translate(-5.45 60.994)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-8.151H38.274V-25.736H26.138Z",
  transform: "translate(-7.633 55.488)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_592",
  "data-name": "Path 592",
  d: "M2.25-2.25H50.986",
  transform: "translate(-2.25 50.195)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144H42.085",
  transform: "translate(-5.902 64.144)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1002",
  "data-name": "Group 1002",
  transform: "translate(60.919 284.407)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_910",
  "data-name": "Group 910",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678-2",
  "data-name": "Group 678",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486-2",
  "data-name": "Path 486",
  d: "M235.068-168.058a3.467,3.467,0,0,0-3.706-3.16H215.731a3.468,3.468,0,0,0-3.707,3.16v20.214a3.468,3.468,0,0,0,3.707,3.16h15.631a3.467,3.467,0,0,0,3.706-3.16Z",
  transform: "translate(-212.024 174.841)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489-2",
  "data-name": "Path 489",
  d: "M220.819-174.885h14.233v-3.565H220.819Z",
  transform: "translate(-216.413 178.45)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492-2",
  "data-name": "Path 492",
  d: "M220.819-115.914h14.233v-.892H220.819Z",
  transform: "translate(-216.413 147.474)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495-2",
  "data-name": "Path 495",
  d: "M212.168-162.192h22.9",
  transform: "translate(-212.096 170.282)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498-2",
  "data-name": "Path 498",
  d: "M212.168-127.273h22.9",
  transform: "translate(-212.096 152.698)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_747-2",
  "data-name": "Path 747",
  d: "M230.214-149.994s2.5,3.853,2.5,5.236a2.506,2.506,0,0,1-2.5,2.5,2.506,2.506,0,0,1-2.505-2.5C227.709-146.141,230.214-149.994,230.214-149.994Z",
  transform: "translate(-218.692 163.247)",
  fill: "#48b05e",
  fillRule: "evenodd"
})))));

var SvgToCompanyStock = function SvgToCompanyStock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216.25,
    height: 57.718,
    viewBox: "0 0 216.25 57.718",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToCompanyStock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/to-company-stock.3efc03e3.svg";
export { ForwardRef as ReactComponent };